import { render, staticRenderFns } from "./CityRow.vue?vue&type=template&id=585065e5&"
import script from "./CityRow.vue?vue&type=script&lang=js&"
export * from "./CityRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports